import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import { api, endpoint } from "../../api";
import appConfig from "@/config/appConfig";
import CustomReportBody from "../CustomReport/redesign/CustomReportBody";
import { flare } from "@flareapp/js";

const GenerateReport = ({ id }) => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [layouts, setLayouts] = useState({});
  const [gridData, setGridData] = useState([]);

  const getCustomReport = async () => {
    if (!isLoading && id) {
      try {
        setIsLoading(true);
        const { result } = await api.get(endpoint.customReportTemplate + "/" + id);
        if (result) {
          setData(result);
        }
      } catch (error) {
        flare.report(error);
        // eslint-disable-next-line no-console
        console.log(error.message);
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    getCustomReport();
  }, [id]);

  useEffect(() => {
    document.title = `${appConfig.name} - Generate Report Template`;
  }, []);

  return (
    <div>{data && <CustomReportBody {...{ mode: "create", id, layouts, setLayouts, gridData, setGridData }} />}</div>
  );
  // return <div>{data && <CustomReportForm mode="generate" data={data} />}</div>;
};

export default GenerateReport;

GenerateReport.propTypes = {
  id: PropTypes.string.isRequired,
};
